import React from "react";
import {Helmet} from "react-helmet";
import ContentSection from "../../cmp/page/ContentSection";
import { IArticle } from "../interfaces/IArticle";
import CmsArticle from "./CmsArticle";
import { useCmsData } from "../../hooks/useCmsData";
import { useParams } from "react-router-dom";

interface ICmsArticlePage {
    language: ("de" | "en")
}

const CmsArticlePage : React.FC<ICmsArticlePage> = ({language}) => {
    const params = useParams();
    const [data] = useCmsData<Array<{"_translations": Array<IArticle>}>>({docType: "article", additonalQueryString: `&& seoName == '${params?.articleId}'`, fields: `"_translations": *[_type == "translation.metadata" && references(^._id)].translations[].value->{
        headline,
        subheadline,
        category,
        seoName,
        content,
        image,
        author,
        language
    }`});
    
    const articleProps = data?.[0]._translations?.find(p => p.language === language);
    return <>
        <Helmet>
            <title>{articleProps?.headline}</title>
            <meta name="description" content={articleProps?.subheadline} />
            <meta name="robots" content="all" />
            {data?.[0]._translations?.filter(fp => fp?.language !== language).map(page => <link rel="alternate" hrefLang={page?.language} href={`/${page?.language}/${page?.language === "de" ? "artikel" : "article"}/${page?.seoName}`} title={page?.headline} />)}
        </Helmet>
        <ContentSection>
            {articleProps && <CmsArticle {...articleProps} />}
        </ContentSection>
    </>
}

export default CmsArticlePage;